export interface HelpDeskTicket {
    id: number;
    status: number;   // HelpdeskEventStatus
    categoryId: number;
    lastUpdated: string;
    title: string;
    message: string;
    queuePosition: number;
    statusDisplay?: string;
    categoryDisplay?: string;
    assignedTo?: null | AssignedTo;
    assignedDate?: null | string;
    creatorOnline?: boolean;
    createDate?: string;
}

export interface HelpDeskCategory {
    id: number;
    name: string;
    observersCount: number;
}

interface AssignedTo {
  userId: string;
  assignedName: string;
}

export enum ChatStatus {
  SENT = 0,
  DELIVERED = 1
}

// public static final short STATUS_SENT = 0;
// public static final short STATUS_DELIVERED = 1;
// public static final short STATUS_READ = 2;

export enum HelpdeskEventStatus {
  UNKNOWN = -1,
  QUEUE = 0,
  ACTIVE = 1,
  CLOSED_BY_CUSTOMER = 2,
  CLOSED_BY_EMPLOYEE = 3,
  EXPIRED = 4,
}